import { TOGGLE_VIEW } from './const';

export const toggleView = () => ({
    type: TOGGLE_VIEW
});
